import { simpleGqlClient } from '@/graphql/simple-client.jsx';

const query = `query ExecutiveDashboard($input: ExecutiveDashboardInput!) {
  executiveDashboard(input: $input) {
    rango { desde hasta }
    kpis_financieros {
      total_facturado total_costos margen_total margen_pct cartera_por_cobrar cartera_vencida
      cartera_vencida_pct pagos_recibidos pagos_pendientes liquidaciones_pendientes_pago liquidaciones_total_pendiente
    }
    kpis_operativos {
      guias_emitidas guias_entregadas guias_retenidas guias_en_reparto fojas_abiertas repartos_activos sla_en_riesgo sla_vencidas
    }
    rankings {
      top_clientes_rentables { id nombre total_facturado total_costos margen_total margen_pct saldo_pendiente guias }
      top_lineas_rentables { id nombre total_facturado total_costos margen_total margen_pct saldo_pendiente guias }
      top_clientes_morosos { id nombre total_facturado total_costos margen_total margen_pct saldo_pendiente guias }
      guias_con_margen_negativo { guia_id cliente_id cliente_nombre linea_id fecha facturado costos margen }
    }
    series {
      facturacion_diaria { fecha total }
      costos_diarios { fecha total }
      margen_diario { fecha total }
      cartera_diaria { fecha total }
    }
    comparativo {
      total_facturado_pct margen_total_pct cartera_vencida_pct guias_entregadas_pct sla_vencidas_pct
    }
  }
}`;

export async function fetchExecutiveDashboard(input) {
  const result = await simpleGqlClient.query(query, { input });
  if (result.errors?.length) {
    throw new Error(result.errors[0].message || 'No se pudo obtener el panel ejecutivo.');
  }
  return result?.data?.executiveDashboard;
}

export function exportExecutiveDashboardStub() {
  // TODO(api): exponer endpoint CSV/PDF y auditar export.
  return Promise.resolve({ ok: true });
}
